const FontSize = {
    NAVIGATION: "16px",
    TITLE_1: "50px",
    TITLE_2: "34px",
} as const;

export type FontSizeType = typeof FontSize[keyof typeof FontSize];

export default FontSize;
